export enum AlarmType {

  GAS_TANK_OPEN = 'GAS_TANK_OPEN',
  TRAILER_DOORS_OPEN = 'TRAILER_DOORS_OPEN',
  ALARM_OFF = 'ALARM_OFF',
  PANIC_BUTTON = 'PANIC_BUTTON',
  FREEZER_TEMPERATURE_LOW = 'FREEZER_TEMPERATURE_LOW',
  FREEZER_TEMPERATURE_HIGH = 'FREEZER_TEMPERATURE_HIGH',
  SECOND_COMPARTMENT_FREEZER_TEMPERATURE_LOW = 'SECOND_COMPARTMENT_FREEZER_TEMPERATURE_LOW',
  SECOND_COMPARTMENT_FREEZER_TEMPERATURE_HIGH = 'SECOND_COMPARTMENT_FREEZER_TEMPERATURE_HIGH',
  FREEZER_OFF = 'FREEZER_OFF',
  FUEL_LEVEL_LOW = 'FUEL_LEVEL_LOW',
  TRAILER_DISCONNECTED = 'TRAILER_DISCONNECTED',
  DVR_POWER = 'DVR_POWER',
  REFUELING = 'REFUELING',
  DEFUELING = 'DEFUELING',
  OFF_ROUTE = 'OFF_ROUTE',
  VOLTAGE_LOW = 'VOLTAGE_LOW',
  OFFLINE = 'OFFLINE',
  RIGHT_LM_SENSOR = 'RIGHT_LM_SENSOR',
  LEFT_LM_SENSOR = 'LEFT_LM_SENSOR',
  BACK_LM_SENSOR = 'BACK_LM_SENSOR',
  LOOP_DOOR = 'LOOP_DOOR',
  LOOP_RIGHT = 'LOOP_RIGHT',
  LOOP_LEFT = 'LOOP_LEFT',
  LOOP_TOP_CEILING = 'LOOP_TOP_CEILING',
  DOORS_OPEN = 'DOORS_OPEN',
  RIGHT_LOCK = 'RIGHT_LOCK',
  LEFT_LOCK = 'LEFT_LOCK',
  ENGINE_OIL = 'ENGINE_OIL',
  ENGINE_OIL_TEMPERATURE = 'ENGINE_OIL_TEMPERATURE',
  ENGINE_OIL_LEVEL = 'ENGINE_OIL_LEVEL',
  ENGINE_COOLANT_LEVEL = 'ENGINE_COOLANT_LEVEL',
  ENGINE_COOLANT_TEMPERATURE = 'ENGINE_COOLANT_TEMPERATURE',
  ENGINE_MIL_INDICATOR = 'ENGINE_MIL_INDICATOR',
  ENGINE_EMISSION_SYSTEM_FAILURE_MIL_INDICATOR = 'ENGINE_EMISSION_SYSTEM_FAILURE_MIL_INDICATOR',
  BRAKE_FAILURE = 'BRAKE_FAILURE',
  ANTI_LOCK_BRAKE_SYSTEM_FAILURE = 'ANTI_LOCK_BRAKE_SYSTEM_FAILURE',
  WORN_BRAKE_LININGS = 'WORN_BRAKE_LININGS',
  STEERING_FLUID_LEVEL = 'STEERING_FLUID_LEVEL',
  STEERING_FAILURE = 'STEERING_FAILURE',
  TRANSMISSION_FLUID_TEMPERATURE = 'TRANSMISSION_FLUID_TEMPERATURE',
  TRANSMISSION_FAILURE = 'TRANSMISSION_FAILURE',
  AIR_FILTER_CLOGGED = 'AIR_FILTER_CLOGGED',
  FUEL_FILTER_DIFFERENTIAL_PRESSURE = 'FUEL_FILTER_DIFFERENTIAL_PRESSURE',
  HAZARD_WARNING = 'HAZARD_WARNING',
  BATTERY_CHARGING_CONDITION = 'BATTERY_CHARGING_CONDITION',
  TIRE_FAILURE_MALFUNCTION = 'TIRE_FAILURE_MALFUNCTION',
  ADBLUE_LEVEL = 'ADBLUE_LEVEL',
  AUXILIARY_AIR_PRESSURE = 'AUXILIARY_AIR_PRESSURE',
  LOOP_OFF = 'LOOP_OFF',
  DOORS_OFF = 'DOORS_OFF',
  LOOP_ALARM = 'LOOP_ALARM',
  DOORS_ALARM = 'DOORS_ALARM',
  TPMS_PRESSURE_UNDER_CRITICAL = 'TPMS_PRESSURE_UNDER_CRITICAL',
  TPMS_PRESSURE_UNDER_WARNING = 'TPMS_PRESSURE_UNDER_WARNING',
  TPMS_PRESSURE_OVER_CRITICAL = 'TPMS_PRESSURE_OVER_CRITICAL',
  TPMS_PRESSURE_OVER_WARNING = 'TPMS_PRESSURE_OVER_WARNING',
  TPMS_TEMPERATURE_OVER_CRITICAL = 'TPMS_TEMPERATURE_OVER_CRITICAL',
  TPMS_TEMPERATURE_OVER_WARNING = 'TPMS_TEMPERATURE_OVER_WARNING'
}

export const TELL_TALE_ALARMS = [
  'ENGINE_OIL',
  'ENGINE_OIL_TEMPERATURE',
  'ENGINE_OIL_LEVEL',
  'ENGINE_COOLANT_LEVEL',
  'ENGINE_COOLANT_TEMPERATURE',
  'ENGINE_MIL_INDICATOR',
  'ENGINE_EMISSION_SYSTEM_FAILURE_MIL_INDICATOR',
  'BRAKE_FAILURE',
  'ANTI_LOCK_BRAKE_SYSTEM_FAILURE',
  'WORN_BRAKE_LININGS',
  'STEERING_FLUID_LEVEL',
  'STEERING_FAILURE',
  'TRANSMISSION_FLUID_TEMPERATURE',
  'TRANSMISSION_FAILURE',
  'AIR_FILTER_CLOGGED',
  'FUEL_FILTER_DIFFERENTIAL_PRESSURE',
  'HAZARD_WARNING',
  'BATTERY_CHARGING_CONDITION',
  'TIRE_FAILURE_MALFUNCTION',
  'ADBLUE_LEVEL',
  'AUXILIARY_AIR_PRESSURE'
];

export const TPMS_ALARMS = [
  'TPMS_PRESSURE_UNDER_CRITICAL',
  'TPMS_PRESSURE_UNDER_WARNING',
  'TPMS_PRESSURE_OVER_CRITICAL',
  'TPMS_PRESSURE_OVER_WARNING',
  'TPMS_TEMPERATURE_OVER_CRITICAL',
  'TPMS_TEMPERATURE_OVER_WARNING'
];
